var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "brochure-selection__item" }, [
    _c("div", { staticClass: "brochure-selection__item-image" }, [
      _c("picture", [
        _c("img", {
          attrs: {
            src: `${_vm.brochure.imageUrl}?format=webp`,
            alt: _vm.brochure.name,
            loading: "lazy",
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "brochure-selection__item-text" }, [
      _c(
        "div",
        {
          staticClass: "brochure-selection__item-title",
          class: {
            "brochure-selection__item-titleTs":
              _vm.brandName === _vm.Brand.Travelsphere,
          },
        },
        [_vm._v(_vm._s(_vm.brochure.name))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "brochure-selection__item-id" }, [
        _vm._v(_vm._s(_vm.brochure.code)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }